import axios from "axios";
import { hasMemberFlag } from "@/utils/hub";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const NO_RETRY_PATHS = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/session", "/auth/logout", "/admin/"];

let refreshPromise = null;
let sessionLostHandler = null;

export function onSessionLost(handler) {
  sessionLostHandler = handler;
}

export function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${API}/auth/refresh`, null, { withCredentials: true, skipAuthRetry: true })
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}

function shouldRetry(error) {
  const config = error.config;
  const url = config?.url || "";
  return Boolean(config)
    && error.response?.status === 401
    && !config.skipAuthRetry
    && url.startsWith(API)
    && !NO_RETRY_PATHS.some((path) => url.includes(path))
    && hasMemberFlag();
}

async function retryAfterRefresh(error) {
  if (!shouldRetry(error)) return Promise.reject(error);
  try {
    await refreshSession();
  } catch (refreshError) {
    sessionLostHandler?.(refreshError);
    return Promise.reject(error);
  }
  return axios({ ...error.config, skipAuthRetry: true });
}

// Silent access-token renewal: one refresh per expiry, then the original request is replayed once.
axios.interceptors.response.use((response) => response, retryAfterRefresh);
